import React from 'react';
import Policy from 'products/nomad_insurance/views/Policy';

/**
 * Nomad Citizen Member Guide.

 * Reuses the Policy view with the Nomad Citizen product and theme. Content is managed 
 * in Contentful under the `policy` content type with `product: nomad-citizen`.
 */

const MemberGuide = () => (
  <Policy
    product="nomad-citizen"
    title="Nomad Citizen member guide"
    color="fountain"
    hideAddonLabel
  />
);

export default MemberGuide;
